var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 13165",
    d: "M12.8574 4.28589L7.14314 10.0002",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 13166",
    d: "M12.8574 15.7145L7.14314 10.0002",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack2);
export default __webpack_public_path__ + "static/media/icon-back-2.15ea3b38facfa8efe026ef789f589894.svg";
export { ForwardRef as ReactComponent };